import { Component, OnInit, Input, OnDestroy, ElementRef } from '@angular/core';
import echarts from 'echarts';
@Component({
  selector: 'icc-funnel-voice-send',
  templateUrl: './icc-funnel-voice-send.component.html',
  styleUrls: ['./icc-funnel-voice-send.component.less'],
})
export class IccFunnelVoiceSendComponent implements OnInit, OnDestroy {
  constructor(private el: ElementRef) {}

  // 图谱实例
  chartIns: any;
  // 数据源
  @Input() data: {
    receive: number; // 接收量
    send: number; // 发送量
    call: number; // 呼出量
    answer: number; // 接听量
  };
  // 自适应函数
  resizeCharts = () => {
    if (this.chartIns) {
      this.chartIns.resize();
    }
  };

  ngOnInit() {
    setTimeout(() => {
      this.createLineChart('chart-el');
    }, 100);
    window.addEventListener('resize', this.resizeCharts);
  }
  ngOnDestroy() {
    if (this.chartIns) {
      this.chartIns.dispose();
      this.chartIns = null;
    }
    window.removeEventListener('resize', this.resizeCharts);
  }
  /* 生成图谱 */
  createLineChart(chartCls) {
    const elCollection = this.el.nativeElement.getElementsByClassName(chartCls);
    if (!this.chartIns && elCollection.length) {
      this.chartIns = echarts.init(elCollection[0]);
    }
    this.chartIns.setOption({
      calculable: true,
      color: ['rgb(52,163,255)', 'rgb(102,185,255)', 'rgb(156,210,255)', 'rgb(204,234,254)'],
      series: [
        {
          name: '漏斗图',
          type: 'funnel',
          left: '25%',
          right: '25%',
          top: '0',
          bottom: '10%',
          minSize: '0%',
          maxSize: '100%',
          gap: 10,
          label: {
            show: true,
            position: 'left',
            formatter: '{b|{b}}{a|{c}次}',
            rich: {
              a: {
                color: '#000',
                fontSize: 16,
                padding: [0, 0, 0, 5],
              },
              b: {
                color: '#49536e',
                fontSize: 14,
              },
            },
          },
          labelLine: {
            length: 30,
            lineStyle: {
              width: 1,
              type: 'solid',
            },
          },
          data: [{ value: this.data.receive, name: '接收量' }, { value: this.data.send, name: '提交量' }, { value: this.data.call, name: '呼出量' }, { value: this.data.answer, name: '接听量' }],
        },
        {
          z: 1,
          top: 36,
          height: 336,
          type: 'graph',
          layout: 'none',
          symbolSize: 0,
          roam: false,
          edgeSymbol: ['circle', 'arrow'],
          lineStyle: {
            normal: {
              width: 2,
            },
          },
          edgeLabel: {
            normal: {
              show: true,
              rotate: 90,
              position: 'middle',
              backgroundColor: '#e4f5da',
              borderRadius: 4,
              color: '#333',
              verticalAlign: 'middle',
              fontSize: 14,
              legendHoverLink: true,
              padding: [3, 10, 5, 10],
              formatter(d) {
                // console.log('test:', d);
                if (d.value) {
                  let ins = '{img1|} ' + '{words| 转化率 ' + d.value + '%}';
                  return ins;
                }
              },
              rich: {
                img1: {
                  backgroundColor: {
                    image: './assets/images/btnIcon/refresh.png',
                  },
                  width: 18,
                  height: 16,
                },
                words: {
                  color: '#333',
                  position: 'right',
                  fontSize: 14,
                  lineHeight: 20,
                  padding: [0, 0, 0, 0],
                },
              },
            },
          },
          data: [
            {
              name: '接收量',
              x: 100,
              y: 0,
            },
            {
              name: '提交量',
              x: 100,
              y: 40,
            },
            {
              name: '呼出量',
              x: 100,
              y: 70,
            },
            {
              name: '接听量',
              x: 100,
              y: 100,
            },
          ],
          links: [
            {
              source: '接收量',
              target: '提交量',
              value: this.data.receive ? ((this.data.send / this.data.receive) * 100).toFixed(2) : '0',
              lineStyle: {
                normal: {
                  curveness: 5,
                  color: {
                    type: 'linear',
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      {
                        offset: 0,
                        color: 'rgb(52,163,255)', // 0% 处的颜色
                      },
                      {
                        offset: 1,
                        color: 'rgb(102,185,255)', // 100% 处的颜色
                      },
                    ],
                    global: false, // 缺省为 false
                  },
                },
              },
            },
            {
              source: '提交量',
              target: '呼出量',
              value: this.data.send ? ((this.data.call / this.data.send) * 100).toFixed(2) : '0',
              lineStyle: {
                normal: {
                  curveness: 6,
                  color: {
                    type: 'linear',
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      {
                        offset: 0,
                        color: 'rgb(102,185,255)', // 0% 处的颜色
                      },
                      {
                        offset: 1,
                        color: 'rgb(156,210,255)', // 100% 处的颜色
                      },
                    ],
                    global: false, // 缺省为 false
                  },
                },
              },
            },
            {
              source: '呼出量',
              target: '接听量',
              value: this.data.call ? ((this.data.answer / this.data.call) * 100).toFixed(2) : '0',
              lineStyle: {
                normal: {
                  curveness: 5,
                  color: {
                    type: 'linear',
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      {
                        offset: 0,
                        color: 'rgb(156,210,255)', // 0% 处的颜色
                      },
                      {
                        offset: 1,
                        color: 'rgb(204,234,254)', // 100% 处的颜色
                      },
                    ],
                    global: false, // 缺省为 false
                  },
                },
              },
            },
            {
              source: '--',
              target: '接听量',
              value: 0,
              lineStyle: {},
            },
          ],
        },
      ],
    });
  }
}
